import { format, add } from 'date-fns';
import { hr, enGB, de, sl, it, nl } from 'date-fns/locale';

export function formatDate(date: any, dateFormat: string = 'dd. MMM') {
  const { lang } = useLanguage();
  // locales mapper
  const localesMapper = { 'en': enGB, 'de': de, 'it': it, 'nl': nl, 'sl': sl, 'hr': hr }
  return format(date, dateFormat, { locale: localesMapper[lang.value] || enGB });
}

export function twoYearsFromToday() {
  const today = new Date();
  return add(today, { years: 2 });
}